import EmailSenderLayout from "../EmailSenderLayout";
import { NSARouterMakerProps } from "namirasoft-account-react";
import { EmailSenderEntities } from "../EmailSenderEntities";
import { EmailSenderRouterProps } from "../EmailSenderRouterProps";

export interface IProviderPageProps extends NSARouterMakerProps, EmailSenderRouterProps
{ }

function ProviderViewPage(props: IProviderPageProps)
{
	return (
		<EmailSenderLayout {...props}
			action={{
				title: "",
				menus: {}
			}}
			pages={{
				entity: EmailSenderEntities.provider(props),
				view: {}
			}}>
			<></>
		</EmailSenderLayout>
	);
}

export default ProviderViewPage;